export const FORM_NAME = 'verify';



// WEBPACK FOOTER //
// ./src/verify/constants.js